import React, { useEffect, useRef, useState } from "react";
import Breadcrumbs from "../common/breadcrumbs";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import Aos from "aos";
import { all_routes } from "../router/all_routes";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import "yet-another-react-lightbox/styles.css";
import { defaultDropOffDate, defaultDropOffTime, defaultPickUpDate, defaultPickUpTime, DetailsCarData, formatedDateTime, getAfterDayDate,  getBookingRequestMsg,  getTodayDate, ListMasterData, MakeRequest, S3CDNURL, showTitleMaster, timeOptions, triggerDatePicker } from "../../functionsMaster";
// import Select from 'react-select';
import CarPackagesSelect from "../common/carPackagesSelect";
// import { Select } from "antd";

const listingDetails = () => {
  const BookNowDivRef = useRef(null);
  const scrollToBookNow = () => {
     BookNowDivRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const navigate = useNavigate();

  // const inputPickupDate = useRef(null);
  const inputReturnDate = useRef(null);

  const [listPickTimeOpen, setListPickTimeOpen] = useState(false);
  const [listRerurnTimeOpen, setListRerurnTimeOpen] = useState(false);  
    
        const [pickUpDate, setPickUpDate] = useState(defaultPickUpDate());
        const [pickUpTime, setPickUpTime] = useState(defaultPickUpTime());
        const [dropOffDate, setDropOffDate] = useState(defaultDropOffDate());
        const [dropOffTime, setDropOffTime] = useState(defaultDropOffTime());

        // === Handle Pickup Date Selection ===
        const handlePickUpDateChange = (value) => {
          setPickUpDate(value);
          localStorage.setItem('filPickUpDate', value);
          setListPickTimeOpen(true);
          // setPickUpTimeOpen(true);
          // focus the select box
          // timeSelectRef.current?.focus();
        };

        // === Handle Pickup Time Selection ===
        const handlePickUpTimeChange = (value) => {
          setPickUpTime(value);
          localStorage.setItem('filPickUpTime', value || '');
        };

        // === Handle Drop-off Date Selection ===
        const handleDropOffDateChange = (value) => {
          setDropOffDate(value);
          localStorage.setItem('filDropOffDate', value);
          setListRerurnTimeOpen(true)
        };

        // === Handle Drop-off Time Selection ===
        const handleDropOffTimeChange = (value) => {
          setDropOffTime(value);
          localStorage.setItem('filDropOffTime', value || '');
        };

  const routes = all_routes;
  const { id } = useParams(); // its a car slug actually
  const slug = id;
  const bigImgSliderRef = useRef(null);
  const thumbnailSliderRef = useRef(null);

  const defaulValue = {
      name: '',
      email: '',
      phone: '',
      comment: '',
      apiCall: false,
      service: 5,
      location: 5,
      facilities: 5,
      valueForMoney: 5,
      cleanliness: 5,
    };
  const [formData, setFormData] = useState(defaulValue);
  const [response, setResponse] = useState({ status: 0, message: '' });
  async function submitReviewRequest() {
      setFormData({ ...formData, apiCall: true });
      const data = await MakeRequest({ ...formData, carID: carData._id }, "carReviews");
      setResponse(data);
      setFormData(defaulValue);
      return false;
  }

  useEffect(() => {
    if (bigImgSliderRef.current && thumbnailSliderRef.current) {
      bigImgSliderRef.current.slickGoTo(0);
      thumbnailSliderRef.current.slickGoTo(0);
    }
  }, []);
  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
    setTimeout(() => {
      scrollToBookNow();
    }, 1786);
  }, [slug]);

  const [loading, setLoading] = useState(true);
  
  const [carData, setcarData] = useState({ pricing: [] });
  const [selectedPackage, setSelectedPackage] = useState(localStorage.getItem('pkgID'));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const temp = await DetailsCarData({ slug });
        // console.log(temp);
        if (temp?.data?.length > 0) {
          setcarData(temp.data[0]);
          localStorage.setItem('rentDepotit', temp.data[0].localDriveRate ? temp.data[0].localDriveRate : 5000);
          localStorage.setItem('forMessage', `I need ${temp.data[0].name} for Self Drive Car Rental. I need car from `);
          let pkgID = localStorage.getItem('pkgID');
          localStorage.setItem('carID', temp.data[0]._id);
          if (!pkgID && temp.data[0].pricing && temp.data[0].pricing.length > 1) {
            pkgID = temp.data[0].pricing[1].pkgID;
            localStorage.setItem('pkgID', pkgID);
            setSelectedPackage(pkgID);
          }
        } else {
          window.location.href = "/";
        }
      } catch (error) {
         window.location.href = "/";
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchData();
    }
  }, [slug]);

  
    const [carCategory, setCarCategory] = useState([]); // temp
    const [carBrand, setCarBrand] = useState([]); // temp1
    // const [carModel, setCarModel] = useState([]); // temp2
    // const [carColor, setCarColor] = useState([]); // temp3
    // const [carSeat, setCarSeat] = useState([]); // temp4
     const [carFuel, setCarFuel] = useState([]); // temp5
    // const [carDoor, setCarDoor] = useState([]); // temp6
    // const [carCylinder, setCylinder] = useState([]); // temp7
    const [carTransmission, setCarTransmission] = useState([]); // temp8
    // const [carSteering, setCarSteering] = useState([]); // temp9
    // const [carFeatures, setCarFeatures] = useState([]); // temp10
    // const [carSafetyFeatures, setCarSafetyFeatures] = useState([]); // temp11
  
    // const [branchLocation, setBranchLocation] = useState([]); // temp12
    const [carsPackages, setCarsPackages] = useState([]); // temp13   
  
  useEffect(() => {
    const CACHE_DURATION = 4 * 60 * 60 * 1000; // 4 hours in milliseconds
  
    const fetchData = async () => {    
      const temp = await ListMasterData('carsPackages', { status: 1 });
      setCarsPackages(temp.data && temp.data.length > 0 ? temp.data : []);
  
      const config = [
        { key: 'carCategory', setter: setCarCategory },
        { key: 'carBrand', setter: setCarBrand },
        // { key: 'carModel', setter: setCarModel },
        // { key: 'carColor', setter: setCarColor },
        // { key: 'carSeat', setter: setCarSeat },
        { key: 'carFuel', setter: setCarFuel },
        // { key: 'carDoor', setter: setCarDoor },
        // { key: 'carCylinder', setter: setCylinder },
        { key: 'carTransmission', setter: setCarTransmission },
        // { key: 'carSteering', setter: s  etCarFeatures },
        // { key: 'carSafetyFeatures', setter: setCarSafetyFeatures },
        // { key: 'branchLocation', setter: setBranchLocation },
      ];
  
      await Promise.all(
        config.map(async ({ key, setter }) => {
          const cacheKey = `masterData_${key}`;
          const cacheRaw = localStorage.getItem(cacheKey);
  
          if (cacheRaw) {
            const { timestamp, data } = JSON.parse(cacheRaw);
            const isExpired = Date.now() - timestamp > CACHE_DURATION;
  
            if (!isExpired && Array.isArray(data)) {
              setter(data);
              return;
            }
          }
  
          // Fetch from API if not cached or expired
          try {
            const res = await ListMasterData(key, { status: 1, limitedData: 'Yes' });
            const data = Array.isArray(res.data) ? res.data : [];
            setter(data);
            if (data && data.length > 0) {
              localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data }));
            }
          } catch (err) {
            console.error(`Failed to fetch ${key}`, err);
            setter([]);
          }
        })
      );
    };
  
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="text-center">
        <img alt="" className="mt-5" src="/loader.gif" />
        <h3 className="text-success mt-3 mb-5">Fetching Car Details</h3>
      </div>
    );  
  }

  return (
    <div className="main-wrapper">
      <Breadcrumbs title={carData.name} subtitle="Car" bg={`${S3CDNURL}${carData.image}`}  />
      <>
        {/* Detail Page Head*/}
        <section className="product-detail-head">
          <div className="container">
            <div className="detail-page-head">
              <div className="detail-headings">
                <div className="star-rated">
                  <ul className="list-rating">
                    <li>
                      <div className="car-brand">
                        <span>
                          <ImageWithBasePath
                            src="assets/img/icons/car-icon.svg"
                            alt="img"
                          />
                        </span>
                        {showTitleMaster(carData.brand, carBrand)}
                      </div>
                    </li>
                    <li>
                      <span className="year">{carData.year}</span>
                    </li>
                    <li className="ratings">
                      <i className="fas fa-star filled" />
                      <i className="fas fa-star filled" />
                      <i className="fas fa-star filled" />
                      <i className="fas fa-star filled" />
                      <i className="fas fa-half filled" />
                      <span className="d-inline-block average-list-rating">
                        (4.7)
                      </span>
                    </li>
                  </ul>
                  <div className="camaro-info">
                    <h3>{carData.name}</h3>
                    <div className="camaro-location">
                      {/* <div className="camaro-location-inner">
                        <i className="bx bx-map" />
                        <span>Location : Miami St, Destin, FL 32550, USA </span>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="details-btn-OLD">
                <div className="camaro-location-inner">
                  <i className="bx bx-show" />
                  <span> Views : {carData.view} </span>
                </div>
                <br />
                <div className="camaro-location-inner">
                  <i className="bx bx-car" />
                  <span> Listed on: {formatedDateTime(carData.createdAt)} </span>
                </div>
                {/* <span className="total-badge">
                  <i className="bx bx-calendar-edit" />
                  Total Booking : 300
                </span>
                <Link to="#">
                  {" "}
                  <i className="bx bx-git-compare" />
                  Compare
                </Link> */}
              </div>
            </div>
          </div>
        </section>
        {/* /Detail Page Head*/}
      </>

      <section className="section product-details pt-4">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="detail-product">
                <div className="pro-info d-none">
                  <div className="pro-badge">
                    <span className="badge-km">
                      <i className="fa-solid fa-person-walking" />
                      4.2 Km Away
                    </span>
                    <Link to="#" className="fav-icon">
                      <i className="fa-regular fa-heart" />
                    </Link>
                  </div>
                  <ul>
                    <li className="del-airport">
                      <i className="fa-solid fa-check" />
                      Airport delivery
                    </li>
                    <li className="del-home">
                      <i className="fa-solid fa-check" />
                      Home delivery
                    </li>
                  </ul>
                </div>

               
                  <div className="slider detail-bigimg">
                    <div className="product-img">
                      <img  
                        src={`${S3CDNURL}${carData.image}`}
                        alt={carData.name}
                        style={{ width: '100%' }}
                      />
                    </div>
                  </div>
              </div>
              <>
                <div className="d-none review-sec pb-0">
                  <div className="review-header">
                    <h4>Extra Service</h4>
                  </div>
                  <div className="lisiting-service">
                    <div className="row">
                      <div className="servicelist d-flex align-items-center col-xxl-3 col-xl-4 col-sm-6">
                        <div className="service-img">
                          <ImageWithBasePath
                            src="assets/img/icons/service-01.svg"
                            alt="Icon"
                          />
                        </div>
                        <div className="service-info">
                          <p>GPS Navigation Systems</p>
                        </div>
                      </div>
                      <div className="servicelist d-flex align-items-center col-xxl-3 col-xl-4 col-sm-6">
                        <div className="service-img">
                          <ImageWithBasePath
                            src="assets/img/icons/service-02.svg"
                            alt="Icon"
                          />
                        </div>
                        <div className="service-info">
                          <p>Wi-Fi Hotspot</p>
                        </div>
                      </div>
                      <div className="servicelist d-flex align-items-center col-xxl-3 col-xl-4 col-sm-6">
                        <div className="service-img">
                          <ImageWithBasePath
                            src="assets/img/icons/service-03.svg"
                            alt="Icon"
                          />
                        </div>
                        <div className="service-info">
                          <p>Child Safety Seats</p>
                        </div>
                      </div>
                      <div className="servicelist d-flex align-items-center col-xxl-3 col-xl-4 col-sm-6">
                        <div className="service-img">
                          <ImageWithBasePath
                            src="assets/img/icons/service-04.svg"
                            alt="Icon"
                          />
                        </div>
                        <div className="service-info">
                          <p>Fuel Options</p>
                        </div>
                      </div>
                      <div className="servicelist d-flex align-items-center col-xxl-3 col-xl-4 col-sm-6">
                        <div className="service-img">
                          <ImageWithBasePath
                            src="assets/img/icons/service-05.svg"
                            alt="Icon"
                          />
                        </div>
                        <div className="service-info">
                          <p>Roadside Assistance</p>
                        </div>
                      </div>
                      <div className="servicelist d-flex align-items-center col-xxl-3 col-xl-4 col-sm-6">
                        <div className="service-img">
                          <ImageWithBasePath
                            src="assets/img/icons/service-06.svg"
                            alt="Icon"
                          />
                        </div>
                        <div className="service-info">
                          <p>Satellite Radio</p>
                        </div>
                      </div>
                      <div className="servicelist d-flex align-items-center col-xxl-3 col-xl-4 col-sm-6">
                        <div className="service-img">
                          <ImageWithBasePath
                            src="assets/img/icons/service-07.svg"
                            alt="Icon"
                          />
                        </div>
                        <div className="service-info">
                          <p>Additional Accessories</p>
                        </div>
                      </div>
                      <div className="servicelist d-flex align-items-center col-xxl-3 col-xl-4 col-sm-6">
                        <div className="service-img">
                          <ImageWithBasePath
                            src="assets/img/icons/service-08.svg"
                            alt="Icon"
                          />
                        </div>
                        <div className="service-info">
                          <p>Express Check-in/out</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Listing Section */}
                {carData.description !== "" && (
                  <>
                    <div className="review-sec mb-0">
                      <div className="review-header">
                        <h4>Description</h4>
                      </div>
                      <div className="description-list">
                        <p>{carData.description}</p>
                      </div>
                    </div>
                  </>
                )}
                {/* /Listing Section */}
                {/* Specifications */}
                <div className="review-sec specification-card ">
                  <div className="review-header">
                    <h4>Specifications</h4>
                  </div>
                  <div className="card-body">
                    <div className="lisiting-featues">
                      <div className="row">
                        <div className="featureslist d-flex align-items-center col-xl-4 col-md-4 col-sm-6">
                          <div className="feature-img">
                            <ImageWithBasePath
                              src="assets/img/specification/specification-icon-1.svg"
                              alt="Icon"
                            />
                          </div>
                          <div className="featues-info">
                            <span>Body </span>
                            <h6>{showTitleMaster(carData.category, carCategory)}</h6>
                          </div>
                        </div>
                        <div className="featureslist d-flex align-items-center col-xl-4 col-md-4 col-sm-6">
                          <div className="feature-img">
                            <ImageWithBasePath
                              src="assets/img/specification/specification-icon-2.svg"
                              alt="Icon"
                            />
                          </div>
                          <div className="featues-info">
                            <span>Make </span>
                            <h6> {showTitleMaster(carData.brand, carBrand)}</h6>
                          </div>
                        </div>
                        <div className="featureslist d-flex align-items-center col-xl-4 col-md-4 col-sm-6">
                          <div className="feature-img">
                            <ImageWithBasePath
                              src="assets/img/specification/specification-icon-3.svg"
                              alt="Icon"
                            />
                          </div>
                          <div className="featues-info">
                            <span>Transmission </span>
                            <h6> {showTitleMaster(carData.transmission, carTransmission)}</h6>
                          </div>
                        </div>
                        <div className="featureslist d-flex align-items-center col-xl-4 col-md-4 col-sm-6">
                          <div className="feature-img">
                            <ImageWithBasePath
                              src="assets/img/specification/specification-icon-4.svg"
                              alt="Icon"
                            />
                          </div>
                          <div className="featues-info">
                            <span>Fuel Type </span>
                            <h6> {showTitleMaster(carData.fuel, carFuel)}</h6>
                          </div>
                        </div>
                        <div className="featureslist d-flex align-items-center col-xl-4 col-md-4 col-sm-6">
                          <div className="feature-img">
                            <ImageWithBasePath
                              src="assets/img/specification/specification-icon-5.svg"
                              alt="Icon"
                            />
                          </div>
                          <div className="featues-info">
                            <span>Mileage </span>
                            <h6>{carData.mileage} KM</h6>
                          </div>
                        </div>
                        <div className="featureslist d-flex align-items-center col-xl-4 col-md-4 col-sm-6">
                          <div className="feature-img">
                            <ImageWithBasePath
                              src="assets/img/specification/specification-icon-6.svg"
                              alt="Icon"
                            />
                          </div>
                          <div className="featues-info">
                            <span>Drivetrian </span>
                            <h6>N/A</h6>
                          </div>
                        </div>
                        <div className="featureslist d-flex align-items-center col-xl-4 col-md-4 col-sm-6">
                          <div className="feature-img">
                            <ImageWithBasePath
                              src="assets/img/specification/specification-icon-7.svg"
                              alt="Icon"
                            />
                          </div>
                          <div className="featues-info">
                            <span>Year</span>
                            <h6>{carData.year}</h6>
                          </div>
                        </div>
                        <div className="featureslist d-flex align-items-center col-xl-4 col-md-4 col-sm-6">
                          <div className="feature-img">
                            <ImageWithBasePath
                              src="assets/img/specification/specification-icon-8.svg"
                              alt="Icon"
                            />
                          </div>
                          <div className="featues-info">
                            <span>AC </span>
                            <h6> -</h6>
                          </div>
                        </div>
                        <div className="featureslist d-flex align-items-center col-xl-4 col-md-4 col-sm-6">
                          <div className="feature-img">
                            <ImageWithBasePath
                              src="assets/img/specification/specification-icon-9.svg"
                              alt="Icon"
                            />
                          </div>
                          <div className="featues-info">
                            <span>VIN </span>
                            <h6> -</h6>
                          </div>
                        </div>
                        <div className="featureslist d-flex align-items-center col-xl-4 col-md-4 col-sm-6">
                          <div className="feature-img">
                            <ImageWithBasePath
                              src="assets/img/specification/specification-icon-10.svg"
                              alt="Icon"
                            />
                          </div>
                          <div className="featues-info">
                            <span>Door </span>
                            <h6> {carData.doors} Doors</h6>
                          </div>
                        </div>
                        <div className="featureslist d-flex align-items-center col-xl-4 col-md-4 col-sm-6">
                          <div className="feature-img">
                            <ImageWithBasePath
                              src="assets/img/specification/specification-icon-11.svg"
                              alt="Icon"
                            />
                          </div>
                          <div className="featues-info">
                            <span>Brake </span>
                            <h6> ABS</h6>
                          </div>
                        </div>
                        <div className="featureslist d-flex align-items-center col-xl-4 col-md-4 col-sm-6">
                          <div className="feature-img">
                            <ImageWithBasePath
                              src="assets/img/specification/specification-icon-12.svg"
                              alt="Icon"
                            />
                          </div>
                          <div className="featues-info">
                            <span>Engine (Hp) </span>
                            <h6>{carData.cylinder}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Specifications */}
                {/* Car Features */}
                <div className="review-sec d-none listing-feature">
                  <div className="review-header">
                    <h4>Car Features</h4>
                  </div>
                  <div className="listing-description">
                    <div className="row">
                      <div className="col-md-4">
                        <ul>
                          <li>
                            <span>
                              <i className="bx bx-check-double" />
                            </span>
                            Multi-zone A/C
                          </li>
                          <li>
                            <span>
                              <i className="bx bx-check-double" />
                            </span>
                            Heated front seats
                          </li>
                          <li>
                            <span>
                              <i className="bx bx-check-double" />
                            </span>
                            Andriod Auto
                          </li>
                          <li>
                            <span>
                              <i className="bx bx-check-double" />
                            </span>
                            Navigation system
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-4">
                        <ul>
                          <li>
                            <span>
                              <i className="bx bx-check-double" />
                            </span>
                            Premium sound system
                          </li>
                          <li>
                            <span>
                              <i className="bx bx-check-double" />
                            </span>
                            Bluetooth
                          </li>
                          <li>
                            <span>
                              <i className="bx bx-check-double" />
                            </span>
                            Keyles Start
                          </li>
                          <li>
                            <span>
                              <i className="bx bx-check-double" />
                            </span>
                            Memory seat
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-4">
                        <ul>
                          <li>
                            <span>
                              <i className="bx bx-check-double" />
                            </span>
                            6 Cylinders
                          </li>
                          <li>
                            <span>
                              <i className="bx bx-check-double" />
                            </span>
                            Adaptive Cruise Control
                          </li>
                          <li>
                            <span>
                              <i className="bx bx-check-double" />
                            </span>
                            Intermittent wipers
                          </li>
                          <li>
                            <span>
                              <i className="bx bx-check-double" />
                            </span>
                            4 power windows
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Car Features */}

                {/* FAQ */}
                <div className="review-sec d-none faq-feature">
                  <div className="review-header">
                    <h4>FAQs</h4>
                  </div>
                  <div className="faq-info">
                    <div className="faq-card">
                      <h4 className="faq-title">
                        <Link
                          className="collapsed"
                          data-bs-toggle="collapse"
                          to="#faqOne"
                          aria-expanded="false"
                        >
                          How old do I need to be to rent a car?
                        </Link>
                      </h4>
                      <div id="faqOne" className="card-collapse collapse">
                        <p>
                          We offer a diverse fleet of vehicles to suit every
                          need, including compact cars, sedans, SUVs and luxury
                          vehicles. You can browse our selection online or
                          contact us for assistance in choosing the right
                          vehicle for you
                        </p>
                      </div>
                    </div>
                    <div className="faq-card">
                      <h4 className="faq-title">
                        <Link
                          className="collapsed"
                          data-bs-toggle="collapse"
                          to="#faqTwo"
                          aria-expanded="false"
                        >
                          What documents do I need to rent a car?
                        </Link>
                      </h4>
                      <div id="faqTwo" className="card-collapse collapse">
                        <p>
                          We offer a diverse fleet of vehicles to suit every
                          need, including compact cars, sedans, SUVs and luxury
                          vehicles. You can browse our selection online or
                          contact us for assistance in choosing the right
                          vehicle for you
                        </p>
                      </div>
                    </div>
                    <div className="faq-card">
                      <h4 className="faq-title">
                        <Link
                          className="collapsed"
                          data-bs-toggle="collapse"
                          to="#faqThree"
                          aria-expanded="false"
                        >
                          What types of vehicles are available for rent?
                        </Link>
                      </h4>
                      <div id="faqThree" className="card-collapse collapse">
                        <p>
                          We offer a diverse fleet of vehicles to suit every
                          need, including compact cars, sedans, SUVs and luxury
                          vehicles. You can browse our selection online or
                          contact us for assistance in choosing the right
                          vehicle for you
                        </p>
                      </div>
                    </div>
                    <div className="faq-card">
                      <h4 className="faq-title">
                        <Link
                          className="collapsed"
                          data-bs-toggle="collapse"
                          to="#faqFour"
                          aria-expanded="false"
                        >
                          Can I rent a car with a debit card?
                        </Link>
                      </h4>
                      <div id="faqFour" className="card-collapse collapse">
                        <p>
                          We offer a diverse fleet of vehicles to suit every
                          need, including compact cars, sedans, SUVs and luxury
                          vehicles. You can browse our selection online or
                          contact us for assistance in choosing the right
                          vehicle for you
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /FAQ */}
                {/* Policies */}
                <div className="review-sec">
                  <div className="review-header">
                    <h4>Policies</h4>
                  </div>
                  <div className="policy-list">
                    <div className="policy-item">
                      <div className="policy-info">
                        <h6>Cancellation Charges</h6>
                        <p>
                          Cancellation charges will be applied as per the policy
                        </p>
                      </div>
                      <Link target="_BLANK" to="/pages/terms-condition">Know More</Link>
                    </div>
                    <div className="policy-item">
                      <div className="policy-info">
                        <h6>Policy</h6>
                        <p>
                          I hereby agree to the terms and conditions of the
                          Lease Agreement with Host
                        </p>
                      </div>
                      <Link target="_BLANK" to={routes.privacyPolicy}>View Details</Link>
                    </div>
                  </div>
                </div>
                {/* /Policies */}
                {/* Reviews */}
                <div className="d-none review-sec listing-review">
                  <div className="review-header">
                    <h4>Reviews</h4>
                  </div>
                  <div className="rating-wrapper">
                    <div className="rating-wraps">
                      <h2>
                        4.5<span>/5</span>
                      </h2>
                      <p>Excellent</p>
                      <h6>Based on 256 Reviews</h6>
                    </div>
                    <div className="rating-progress">
                      <div className="progress-info">
                        <h6>Service</h6>
                        <div className="progress" role="progressbar">
                          <div
                            className="progress-bar bg-primary"
                            style={{ width: "70%" }}
                          />
                        </div>
                        <div className="progress-percent">4.6</div>
                      </div>
                      <div className="progress-info">
                        <h6>Location</h6>
                        <div className="progress" role="progressbar">
                          <div
                            className="progress-bar bg-primary"
                            style={{ width: "85%" }}
                          />
                        </div>
                        <div className="progress-percent">4.8</div>
                      </div>
                      <div className="progress-info">
                        <h6>Value for Money</h6>
                        <div className="progress" role="progressbar">
                          <div
                            className="progress-bar bg-primary"
                            style={{ width: "60%" }}
                          />
                        </div>
                        <div className="progress-percent">3.0</div>
                      </div>
                      <div className="progress-info">
                        <h6>Facilities</h6>
                        <div className="progress" role="progressbar">
                          <div
                            className="progress-bar bg-primary"
                            style={{ width: "65%" }}
                          />
                        </div>
                        <div className="progress-percent">4.5</div>
                      </div>
                      <div className="progress-info">
                        <h6>Cleanliness</h6>
                        <div className="progress" role="progressbar">
                          <div
                            className="progress-bar bg-primary"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <div className="progress-percent">4.8</div>
                      </div>
                    </div>
                  </div>
                  <div className="review-card">
                    <div className="review-head">
                      <h6>Showing 3 guest reviews</h6>
                    </div>
                    <ul>
                      <li>
                        <div className="review-wraps">
                          <div className="review-header-group">
                            <div className="review-widget-header">
                              <span className="review-widget-img">
                                <ImageWithBasePath
                                  src="assets/img/profiles/avatar-01.jpg"
                                  className="img-fluid"
                                  alt="User"
                                />
                              </span>
                              <div className="review-design">
                                <h6>Johnson</h6>
                                <p>02 Jan 2023</p>
                              </div>
                            </div>
                            <div className="reviewbox-list-rating">
                              <p>
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <span> (5.0)</span>
                              </p>
                            </div>
                          </div>
                          <p>
                            It was popularised in the 1960s with the release of
                            Letraset sheets containing Lorem Ipsum passages, and
                            more recently with desktop publishing software like
                            Aldus PageMaker including versions of Lorem Ipsum.It
                            was popularised in the 1960s{" "}
                          </p>
                          <div className="review-reply">
                            <Link className="btn" to="#">
                              <i className="fa-solid fa-reply" />
                              Reply
                            </Link>
                            <div className="review-action">
                              <Link to="#">
                                <i className="fa-regular fa-thumbs-up" />
                                10
                              </Link>
                              <Link to="#">
                                <i className="fa-regular fa-thumbs-down" />
                                12
                              </Link>
                              <Link to="#">
                                <i className="fa-regular fa-heart" />
                                15
                              </Link>
                            </div>
                          </div>
                        </div>
                        <ul>
                          <li>
                            <div className="review-wraps">
                              <div className="review-header-group">
                                <div className="review-widget-header">
                                  <span className="review-widget-img">
                                    <ImageWithBasePath
                                      src="assets/img/profiles/avatar-01.jpg"
                                      className="img-fluid"
                                      alt="User"
                                    />
                                  </span>
                                  <div className="review-design">
                                    <h6>Johnson</h6>
                                    <p>02 Jan 2023</p>
                                  </div>
                                </div>
                                <div className="reviewbox-list-rating">
                                  <p>
                                    <i className="fas fa-star filled" />
                                    <i className="fas fa-star filled" />
                                    <i className="fas fa-star filled" />
                                    <i className="fas fa-star filled" />
                                    <i className="fas fa-star filled" />
                                    <span> (5.0)</span>
                                  </p>
                                </div>
                              </div>
                              <p>
                                It was popularised in the 1960s with the release
                                of Letraset sheets containing Lorem Ipsum
                                passages, and more recently with desktop
                                publishing software like Aldus PageMaker
                                including versions of Lorem Ipsum.It was
                                popularised in the 1960s{" "}
                              </p>
                              <div className="review-reply">
                                <Link className="btn" to="#">
                                  <i className="fa-solid fa-reply" />
                                  Reply
                                </Link>
                                <div className="review-action">
                                  <Link to="#">
                                    <i className="fa-regular fa-thumbs-up" />
                                    10
                                  </Link>
                                  <Link to="#">
                                    <i className="fa-regular fa-thumbs-down" />
                                    12
                                  </Link>
                                  <Link to="#">
                                    <i className="fa-regular fa-heart" />
                                    15
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <div className="review-wraps wrap-card">
                          <div className="review-header-group">
                            <div className="review-widget-header">
                              <span className="review-widget-img">
                                <ImageWithBasePath
                                  src="assets/img/profiles/avatar-02.jpg"
                                  className="img-fluid"
                                  alt="User"
                                />
                              </span>
                              <div className="review-design">
                                <h6>Casandra</h6>
                                <p>Reviewed 25 March 2024</p>
                              </div>
                            </div>
                            <div className="reviewbox-list-rating">
                              <p>
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <span> (5.0)</span>
                              </p>
                            </div>
                          </div>
                          <p>
                            It was popularised in the 1960s with the release of
                            Letraset sheets containing Lorem Ipsum passages, and
                            more recently with desktop publishing software like
                            Aldus PageMaker including versions of Lorem Ipsum.It
                            was popularised in the 1960s with the elease of
                            Letraset sheets containing Lorem Ipsum passages, and
                            more recently with desktop publishing software like
                            Aldus Page Maker including versions of Lorem Ipsum.
                          </p>
                          <div className="review-reply">
                            <Link className="btn" to="#">
                              <i className="fa-solid fa-reply" />
                              Reply
                            </Link>
                            <div className="review-action">
                              <Link to="#">
                                <i className="fa-regular fa-thumbs-up" />
                                10
                              </Link>
                              <Link to="#">
                                <i className="fa-regular fa-thumbs-down" />
                                12
                              </Link>
                              <Link to="#">
                                <i className="fa-regular fa-heart" />
                                15
                              </Link>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* /Reviews */}
                {/* Leave a Reply */}
                <div className="review-sec leave-reply-form mb-0">
                  <div className="review-header">
                    <h4>Leave a Review</h4>
                  </div>
                  <div className="review-list-rating">
                    <div className="row">   
                      <div className="col-xl-4 col-md-6">
                        <div className="set-rating">
                          <p>Service</p>
                          <div className="rating-selection">
                            {[1, 2, 3, 4, 5].map((s) => (
                              <>
                                <input
                                  type="checkbox"
                                  id={`service${s}`}
                                  value={s}
                                  // checked={formData.service === s}
                                  onClick={(e) => {
                                    setFormData({ ...formData, service: e.target.value });
                                  }}
                                />
                                <label htmlFor={`service${s}`} />
                              </>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-md-6">
                        <div className="set-rating">
                          <p>Location</p>
                          <div className="rating-selection">
                            {[1, 2, 3, 4, 5].map((s) => (
                              <>
                                <input
                                  type="checkbox"
                                  id={`location${s}`}
                                  value={s}
                                  // checked={formData.location === s}
                                  onClick={(e) => {
                                    setFormData({ ...formData, location: e.target.value });
                                  }}
                                />
                                <label htmlFor={`location${s}`} />
                              </>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-md-6">
                        <div className="set-rating">
                          <p>Facilities</p>
                          <div className="rating-selection">
                            {[1, 2, 3, 4, 5].map((s) => (
                              <>
                                <input
                                  type="checkbox"
                                  id={`facilities${s}`}
                                  value={s}
                                  // checked={formData.facilities === s}
                                  onClick={(e) => {
                                    setFormData({ ...formData, facilities: e.target.value });
                                  }}
                                />
                                <label htmlFor={`facilities${s}`} />
                              </>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-md-6">
                        <div className="set-rating">
                          <p>Value for Money</p>
                          <div className="rating-selection">
                            {[1, 2, 3, 4, 5].map((s) => (
                              <>
                                <input
                                  type="checkbox"
                                  id={`valueForMoney${s}`}
                                  value={s}
                                  // checked={formData.valueForMoney === s}
                                  onClick={(e) => {
                                    setFormData({ ...formData, valueForMoney: e.target.value });
                                  }}
                                />
                                <label htmlFor={`valueForMoney${s}`} />
                              </>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-md-6">
                        <div className="set-rating">
                          <p>Cleanliness</p>
                          <div className="rating-selection">
                            {[1, 2, 3, 4, 5].map((s) => (
                              <>
                                <input
                                  type="checkbox"
                                  id={`cleanliness${s}`}
                                  value={s}
                                  // checked={formData.cleanliness === s}
                                  onClick={(e) => {
                                    setFormData({ ...formData, cleanliness: e.target.value });
                                  }}
                                />
                                <label htmlFor={`cleanliness${s}`} />
                              </>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="review-list">
                      <ul>
                        <li className="review-box feedbackbox mb-0">
                          <div className="review-details">
                            <form
                              action="/"
                              onSubmit={(e) => {
                                e.preventDefault();
                                submitReviewRequest();
                              }}
                            >
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="input-block">
                                    <label>
                                      Full Name{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Full Name"
                                      value={formData.name}
                                      onChange={(e) => {
                                        setFormData({ ...formData, name: e.target.value });
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="input-block">
                                    <label>
                                      Email Address{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="email"
                                      className="form-control"
                                      placeholder="Enter Email"
                                      value={formData.email}
                                      onChange={(e) => {
                                        setFormData({ ...formData, email: e.target.value });
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-12">
                                  <div className="input-block">
                                    <label>Comment</label>
                                    <textarea
                                      rows={4}
                                      className="form-control"
                                      defaultValue={""}
                                      value={formData.comment}
                                      placeholder="Enter Comment"
                                      onChange={(e) => {
                                        setFormData({ ...formData, comment: e.target.value });
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>


                            <div className={`${response.message ? '' : 'd-none'} alert alert-${response.status === 1 ? 'success' : 'danger'}`}>
                              {response.status === 1 ? 'Thank you for review..' : response.message}
                            </div>

                              <div className="submit-btn text-end">
                                

                  {formData.apiCall ? (
                    <button type="button" className="btn btn-primary submit-review" disabled>
                      Submitting Review
                    </button>
                  ) : (
                    <button type="submit" className="btn btn-primary submit-review">
                      Submit Review
                    </button>
                  )}

                              </div>
                            </form>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* /Leave a Reply */}
              </>
            </div>
            <div ref={BookNowDivRef} className="col-lg-5 theiaStickySidebar-OLD">
              <div className="stickybar-OLD">
                <div className="review-sec mt-0">
                  <div className="review-header">
                    <h4>Pricing</h4>
                  </div>
                  <>
                  {/* <br /  fTime{dropOffTime} */}
                  <div className="mb-3">
                    {carData &&
                    carData?.pricing &&
                    pickUpDate && 
                    dropOffDate && 
                    pickUpTime && 
                    dropOffTime && 
                    <CarPackagesSelect
                      carPackages={carsPackages}
                      carPackagPricing={carData?.pricing}
                      selectedPackage={selectedPackage}
                      setSelectedPackage={setSelectedPackage}
                      pickUpDate={pickUpDate}
                      dropOffDate={dropOffDate}
                      pickUpTime={pickUpTime}
                      dropOffTime={dropOffTime}
                    />}
                  </div>
                  <div className="location-content">
                    <div className="tab-content">
                      <div className="tab-pane fade active show" id="delivery">
                        <form
                          className=""
                          onSubmitCapture={(e) => {
                            e.preventDefault();
                            navigate(`/checkout/${slug}`);
                          }}
                        >
                          <ul>
                            <li className="column-group-main">
                              <div className="input-block m-0">
                                <label>Pickup Date</label>
                              </div>
                              <div className="input-block-wrapp sidebar-form">
                                <div className="input-block  me-lg-2">
                                  <div className="group-img">

                                    <div className="form-wrap">
                                      <DatePicker
                                        style={{ width: '100%' }}
                                        selected={pickUpDate}
                                        onChange={(date) => handlePickUpDateChange(date)}
                                        dateFormat="dd/MM/yy"
                                        className="form-control"
                                        minDate={getTodayDate()}
                                        maxDate={getAfterDayDate(90)}
                                        placeholderText="dd/mm/yy"
                                      />
                                    </div>                                     
                                    {/* <div className="form-wrap" onClick={() => triggerDatePicker(inputPickupDate)}>
                                      <input
                                          required
                                          type="date"
                                          ref={inputPickupDate}
                                          value={pickUpDate}
                                          onChange={(e) => handlePickUpDateChange(e.target.value)}
                                          placeholder={new Date().toLocaleDateString()}
                                          min={getTodayDate()}
                                          max={getAfterDayDate(90)}
                                          className="form-control"
                                        />
                                      <span className="form-icon">
                                        <i className="fa-regular fa-calendar-days" />
                                      </span>
                                    </div> */}
                                  </div>
                                </div>
                                <div className="input-block">
                                  <div className="group-img">
                                    <div className="form-wrap">
                                      <Select
                                        menuIsOpen={listPickTimeOpen}
                                        options={timeOptions}
                                        placeholder="Select Pickup Time"
                                        className="basic-single "
                                        classNamePrefix="select"
                                        defaultValue={timeOptions.find(option => option.value === (pickUpTime ? pickUpTime : ''))}
                                        onMenuOpen={() => setListPickTimeOpen(true)}   // opens on click/focus
                                        onMenuClose={() => setListPickTimeOpen(false)} // closes when user clicks outside
                                        onChange={(selectedOption) => {
                                          console.log(selectedOption);
                                          handlePickUpTimeChange(selectedOption?.value ?? "");
                                          triggerDatePicker(inputReturnDate);
                                          setListPickTimeOpen(false);
                                      }}
                                    />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                            <li className="column-group-main">
                              <div className="input-block m-0">
                                {" "}
                                <label>Return Date</label>
                              </div>
                              <div className="input-block-wrapp sidebar-form">
                                <div className="input-block me-lg-2">
                                  <div className="group-img">
                                    <div className="form-wrap">
                                      <DatePicker
                                        style={{ width: '100%' }}
                                        selected={dropOffDate}
                                        onChange={(date) => handleDropOffDateChange(date)}
                                        dateFormat="dd/MM/yy"
                                        className="form-control"
                                        minDate={pickUpDate}
                                        maxDate={getAfterDayDate(120)}
                                        placeholderText="dd/mm/yy"
                                      />
                                    </div>
                                    {/* <div className="form-wrap" onClick={() => triggerDatePicker(inputReturnDate)}>
                                      <input
                                        required
                                        type="date"
                                        min={pickUpDate}
                                        max={getAfterDayDate(120)}
                                        className="form-control"
                                        value={dropOffDate}
                                        ref={inputReturnDate}
                                        onChange={(e) => handleDropOffDateChange(e.target.value)}
                                        placeholder={new Date().toLocaleDateString()}
                                      />
                                    </div> */}
                                  </div>
                                </div>
                                <div className="input-block">
                                  <div className="group-img">
                                    <div className="form-wrap"> 
                                      <Select
                                        menuIsOpen={listRerurnTimeOpen}
                                        options={timeOptions}
                                        placeholder="Select Return Time"
                                        className="basic-single"
                                        classNamePrefix="select"
                                        defaultValue={timeOptions.find(option => option.value === dropOffTime)}
                                        onMenuOpen={() => setListRerurnTimeOpen(true)}   // opens on click/focus
                                        onMenuClose={() => setListRerurnTimeOpen(false)} // closes when user clicks outside
                                        onChange={(selectedOption) => {
                                          handleDropOffTimeChange(selectedOption?.value);
                                          setListRerurnTimeOpen(false);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                            <li className="d-none column-group-last">
                              <div className="input-block mb-0">
                                <div className="search-btn">
                                  <button
                                    type="submit"
                                    // to={`/checkout/${slug}`}
                                    className="btn btn-primary check-available w-100"
                                  >
                                    Book
                                  </button>
                                  {/* <Link to="/contact-us" className="mt-3 btn btn-theme">
                                    Enquire Us
                                  </Link> */}
                                </div>
                              </div>
                            </li>
                          </ul>
                        </form>
                      </div>
                    </div>
                  </div>
                </>

                </div>
                
                <div className="review-sec extra-service mt-0">
                
                  <div className="row">
                    <div className="col-md-6">
                        <a 
                          href={`https://api.whatsapp.com/send?phone=${process.env.REACT_APP_CONTACT_WHATSAPP}&text=${getBookingRequestMsg()}.`}
                          target="_BLANK"
                          rel="noreferrer"
                          className="btn d-block w-100 btn-success mb-3"
                        >
                          <i className="fa-brands fa-whatsapp" /> &nbsp;
                          Chat
                        </a>
                    </div>
                    <div className="col-md-6">
                      <a href={`tel:${process.env.REACT_APP_CONTACT_MOBILE}`} className="btn d-block w-100 btn-info mb-3">
                        <i className="fa-solid fa-phone"></i> &nbsp;
                        {process.env.REACT_APP_CONTACT_MOBILE}
                      </a>
                    </div>
                    <div className="col-md-6">
                        <Link to="/contact-us" className="btn d-block w-100 btn-danger mb-3">
                          <i className="fa-solid fa-paper-plane"></i> &nbsp;
                          Contact Us
                        </Link>
                    </div>
                    <div className="col-md-6">
                      <a href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL}`} className="btn d-block w-100 btn-warning mb-3">
                        <i className="fa-solid fa-envelope"></i> &nbsp;
                        {process.env.REACT_APP_CONTACT_EMAIL}
                      </a>
                    </div>
                  </div>
                  
                </div>
                <div className="review-sec share-car mt-0">
                  <div className="review-header">
                    <h4>Udaipur Location</h4>
                  </div>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3283.9242687311867!2d73.694642!3d24.559691599999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3967ef83528f7517%3A0x150b459cc254ff!2sNamo%20Cars%20self%20drive%20cars!5e1!3m2!1sen!2sin!4v1759640373448!5m2!1sen!2sin"
                    allowfullscreen
                    className="iframe-video"
                    loading="lazy"
                  />
                </div>
                <div className="review-sec share-car mt-0 mb-0">
                  <div className="review-header">
                    <h4>Social Links</h4>
                  </div>
                  <ul className="nav-social">
                    {/* <li>
                      <Link to="#">
                        <i className="fa-brands fa-facebook-f fa-facebook fi-icon" />
                      </Link>
                    </li> */}
                    <li>
                      <Link to="https://www.instagram.com/namocars/" target="_BLANK">
                        <i className="fab fa-instagram fi-icon" />
                      </Link>
                    </li>
                    {/* <li>
                      <Link to="#">
                        <i className="fab fa-behance fi-icon" />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-pinterest-p fi-icon" />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="fab fa-twitter fi-icon" />{" "}
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="fab fa-linkedin fi-icon" />
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default listingDetails;
